module.exports = "<section class=floating-sidebar-app-view> <div class=\"floating-sidebar-app-view__main floating-sidebar-app-view__main--no-bottom-margin\" ui-view=overview-main> </div> <div class=floating-sidebar-app-view__sidebar ng-class=\"{\n      'floating-sidebar-app-view__sidebar--has-msg': true,\n    }\" ui-view=overview-sidebar> </div> </section> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/overview/states/overview/main.html
// module id = 783
// module chunks = 0